import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm, Resolver } from "react-hook-form";
/* eslint-disable @typescript-eslint/no-explicit-any */
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useCreateNotification } from "../../../apis";
import { EMPTY_NOTIFICATION_FORM_VALUES } from "../../../constants";
import {
  convertNotificationFormDataToCreateRequestBody,
  notificationValidationSchema
} from "../../../helpers";
import { NotificationForm, NotificationFormValues } from "../../forms";
import { NotificationModalProps } from "./NotificationModal.types";

import styles from "./NotificationModal.module.scss";

const NOTIFICATION_FORM_ID = "NOTIFICATION_FORM_ID";

const NotificationModal = ({
  isOpen,
  onClose,
  refetchNotifications
}: NotificationModalProps) => {
  const { t } = useTranslation();

  const form = useForm({
    defaultValues: EMPTY_NOTIFICATION_FORM_VALUES,
    resolver: yupResolver(notificationValidationSchema) as Resolver<any, any>
  });

  const createNotification = useCreateNotification({
    onSuccess: () => {
      refetchNotifications();
      onClose();
      toast.success(t("Notification created successfully"));
    }
  });

  const handleFormSubmit = (formData: NotificationFormValues) => {
    createNotification.mutate(
      convertNotificationFormDataToCreateRequestBody(formData)
    );
  };

  return (
    <FormProvider {...form}>
      <Modal
        formId={NOTIFICATION_FORM_ID}
        title={t("New Notification")}
        isOpen={isOpen}
        onClose={onClose}
        isLoading={createNotification.isLoading}
        contentClassName={styles.content}
        okText={"Create"}
      >
        <NotificationForm
          formId={NOTIFICATION_FORM_ID}
          onSubmit={handleFormSubmit}
        />
      </Modal>
    </FormProvider>
  );
};

export default NotificationModal;
